import React from 'react'
import { useMutation } from '@tanstack/react-query'
import { useAdminSociety } from '../../useAdminSociety'
import {
  Button,
  ButtonVariant,
} from '../../../../../../components/common/Button'
import { useToastNotifications } from '../../../../../../hooks/useToastNotification'
import { ToastType } from '../../../../../../components/common/Toast/toast-type'
import { useAppTranslation } from '../../../../../../hooks/useAppTranslation'
import { downgradeSociety } from '../../../../../../api/admin'

interface SetBasicModalContentProps {
  close: () => void
  societyId: string | undefined
}

export const SetBasicModalContent = ({
  close,
  societyId,
}: SetBasicModalContentProps): React.ReactNode => {
  const { adminSociety } = useAdminSociety(societyId)
  const { setToastNotification } = useToastNotifications()
  const { translate } = useAppTranslation()

  const { isPending, mutate: mutateDowngradeSociety } = useMutation({
    mutationFn: downgradeSociety,
    onSuccess: () => {
      setToastNotification(ToastType.SUCCESS, 'Förening uppgraderad')
      close()
    },
    onError: () => {
      setToastNotification(
        ToastType.DANGER,
        translate('flashMessage.somethingWentWrongError')
      )
    },
  })
  const onDowngradeSociety = async (): Promise<void> => {
    societyId && mutateDowngradeSociety({ societyId })
  }

  if (!adminSociety) {
    return <p>Föreningen kunde inte hittas</p>
  }

  const alreadyBasic = adminSociety.accountType === 'basic'
  const loading = isPending

  return (
    <>
      <div className="flex h-full w-full flex-col gap-6">
        {alreadyBasic ? (
          <p>Föreningen är redan basic.</p>
        ) : (
          <>
            <p>
              {adminSociety.name} kommer att nedgraderas till <b>basic</b>.
            </p>
            <p>
              Föreningen kommer även att att låsas och samtliga partners kommer
              tas bort.
            </p>
          </>
        )}
        <div className="flex flex-wrap justify-end gap-4">
          <Button label="Avbryt" onClick={close} />
          <Button
            variant={ButtonVariant.PRIMARY}
            label="Nedgradera"
            onClick={onDowngradeSociety}
            loading={loading}
            disabled={loading || alreadyBasic}
          />
        </div>
      </div>
    </>
  )
}
